import { useNeoletterUserProfileQuery } from "shared/api/neoletter-user-profile/queries.generated"
import { useAuth } from "shared/lib/useAuth"

import { useUpdateNeoletterUserProfile } from "./useUpdateNeoletterUserProfile"

export function useNeoletterUserProfile() {
  const { isAuthenticated } = useAuth()
  const { data, ...rest } = useNeoletterUserProfileQuery({
    skip: !isAuthenticated
  })
  const activeProjectID =
    data?.neoletterUserProfile?.custom_fields?.active_project_id || null
  const userProfile = data?.neoletterUserProfile

  const { updateProfile } = useUpdateNeoletterUserProfile()

  return {
    ...rest,
    userProfile,
    activeProjectID,
    updateProfile
  }
}
